import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/page/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/page/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/session-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppAccessTokenProvider"] */ "/app/src/context/app-access-token/app-access-token-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryProvider"] */ "/app/src/context/category/category-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomerProvider"] */ "/app/src/context/customer/customer-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalyticsProvider"] */ "/app/src/context/google-analytics/google-analytics-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MerchantProvider"] */ "/app/src/context/merchant/merchant-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MessageProvider"] */ "/app/src/context/message/message-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromotionProvider"] */ "/app/src/context/promotion/promotion-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShoppingCartProvider"] */ "/app/src/context/shopping-cart/shopping-cart-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/scripts/init-client-scripts.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/app/src/styles/leaflet.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/themify.scss");
;
import(/* webpackMode: "eager" */ "/app/src/styles/default.scss");
